import React, { Component } from "react";


export default class HomeCard extends Component {

  render() {
    return (
      <div className="col-sm">
        <div>
          <div className="text-center justify-content-center">
            {this.props.image}
            <div className="mt-4"/>
            <h6 className={this.props.color}>{this.props.title}</h6>
            <p>{this.props.description}</p>
          </div>
        </div>
      </div>
    );
  }
}
